import React, { useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Modal from 'react-modal';
import { TextField, Button, Checkbox, Container, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { getUsername } from '../../context/AuthFunc';
import { useTranslation } from 'react-i18next';
import { addOrganizationUnit} from '../../api/axios';
import OrganizationUnits from '../List/OrganizationUnits';
const NewOrganizationUnit = () => {
    
      const navigate = useNavigate();
    const { t } = useTranslation('global');

    const [name, setName] = useState('');
    const [specialCategory, setSpecialCategory] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    
    const [refreshKey, setRefreshKey] = useState(0);
    useEffect(()=>{
    },)

    const handleSubmit = async (event) => {
        event.preventDefault();
        if(!name){
            setErrMsg(t("newOrganizationUnit.nameRequired"));
            return;
        }
        const newOrganizationUnit = {
            name,
            specialCategory: specialCategory ? 1 : 0
        };
        try{
            const response = await addOrganizationUnit(newOrganizationUnit);
            if(!response.success){
                setErrMsg(t("newTicket.somethingWentWrong"));
                setTimeout(() => setErrMsg(''), 3000);
            }
            else{
                
                setSucc(t("newTicket.successfullyAdded"));
                setName('');
                setSpecialCategory(false);
                
                setTimeout(() => setSucc(''), 3000);
                setRefreshKey(prev => prev + 1);
            }
        }
        catch (error) {
            setErrMsg(t("newTicket.failedToAddTicket"));
        }
    };

    return (
    <Container maxWidth="sm" className="container-employee" sx={{ p: 3, flexShrink: 0 , mt: 4}} >
        <Typography variant="h4" sx={{ mb:4 }}>{t("newOrganizationUnit.newOrganizationUnit")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                            <Grid item xs={12}>
                                <TextField
                                    label={t("newOrganizationUnit.name")}
                                    fullWidth
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Grid>
                        </Grid>
            <Grid item xs={6}>
                <Grid item xs={12}>
                <FormControlLabel
                        control={
                        <Checkbox
                            checked={specialCategory}
                            onChange={(e) => setSpecialCategory(e.target.checked)}
                            value={t("newOrganizationUnit.specialCategory")}
                        />
                    }
                    label={t("newOrganizationUnit.specialCategory")}
                />
                </Grid>
            </Grid>
            
            <Grid item xs={12} sx={{ width:"100%", display:"flex", justifyContent:"flex-end"}}>
                <Button sx={{ width:"50%" }} variant="contained" type="submit">{t("newTicket.add")}</Button>
            </Grid>
            
        </Grid>
    </form>

    {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
    {succ && <Success message={succ} onClose={() => setSucc('')} />}
        <OrganizationUnits key={refreshKey}/>
    </Container>
    );
};

export default NewOrganizationUnit;
